module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-35\">")
    ; __append(escapeFn(title))
    ; __append("</label> \r\n        <div style=\"display: inline-flex;\">\r\n            <select name=\"state\" id=\"propState\">\r\n                ")
    ;  options.forEach(function(option) { 
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn(option.value))
    ; __append("\"\r\n                        ")
    ; __append(escapeFn(currentState.value === option.value ? 'selected="selected"' : ''))
    ; __append(">\r\n                        ")
    ; __append(escapeFn(option.label))
    ; __append("\r\n                    </option>\r\n                ")
    ;  }); 
    ; __append("\r\n            </select>\r\n            <div class=\"nopadding button-opener\">\r\n                <button id=\"browseState\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n            </div>\r\n        </div>   \r\n    </div>\r\n</div>")
  }
  return __output;

}